import { Component, Input } from '@angular/core';
import { ChartData, ChartSeries } from '../../services/chat-stream-event.model';
import { formatCellValue } from '../glippy-table/format-cell';

@Component({
  selector: 'gung-glippy-chart',
  standalone: false,
  templateUrl: './glippy-chart.component.html',
  styleUrl: './glippy-chart.component.scss'
})
export class GlippyChartComponent {
  @Input() data!: ChartData;

  formatValue = formatCellValue;

  /** MVP renders the first series as horizontal bars; the payload allows more (ADR 0003). */
  get series(): ChartSeries | undefined {
    return this.data?.series?.[0];
  }

  private get max(): number {
    return (this.series?.values ?? []).reduce((m, v) => Math.max(m, v), 0);
  }

  /** Bar width as a percentage of the largest value (0 when every value is 0). */
  barPercent(value: number): number {
    return this.max > 0 ? (value / this.max) * 100 : 0;
  }

  valueAt(index: number): number {
    return this.series?.values?.[index] ?? 0;
  }
}
